import Vue from 'vue'
import Router from 'vue-router'
import notFound from '@/views/not-found'
import isMobile from '@/utils/is-mobile'

// mobile
import mobileHome from '@/views/mobile/home'

const mobileIndex = () => import('@/views/mobile/index');
const newsAnnouncement = () => import('@/views/mobile/mobile-news')
const mobileNewsDetail = () => import('@/views/mobile/mobile-news/detail')

const teacherResource = () => import('@/views/mobile/teachers')
const teacherDetails = () => import('@/views/mobile/teachers/details')
const teacherInfo = () => import('@/views/mobile/teachers/info')
const outstandingTeacher = () => import('@/views/mobile/teachers/outstanding')
const postdoctor = () => import('@/views/mobile/teachers/postdoctor')
const mobileHeader = () => import('@/views/mobile/global-header')

const mobileAbout = () => import('@/views/mobile/academy-overview/overview');
const mobileProfile = () => import('@/views/mobile/academy-overview/introduce');
const mobileLeaders = () => import('@/views/mobile/academy-overview/leaders');
const mobilePrevious = () => import('@/views/mobile/academy-overview/previous');
const mobileContact = () => import('@/views/mobile/academy-overview/contact');

const mobileCultivate = () => import('@/views/mobile/cultivate')
const mobileCultivateNav = () => import('@/views/mobile/cultivate/nav')

const mobileCenter = () => import('@/views/mobile/center')

const mobileTeachers = () => import('@/views/mobile/cultivate/postgraduate/teachers')
const mobileManagement = () => import('@/views/mobile/cultivate/postgraduate/management')
// const mobileManagementDetail =
//  () => import('@/views/mobile/cultivate/postgraduate/management-detail')
// const detail = () => import('@/views/cultivate/detail')

// const teacherDetail = () => import('@/views/cultivate/teacher-detail')

const mobileResearch = () => import('@/views/mobile/research')
const mobileResearchNav = () => import('@/views/mobile/research/nav')
const mobileBases = () => import('@/views/mobile/research/bases')
const mobileResults = () => import('@/views/mobile/research/results')
// const mobileDirectionsDetails = () => import('@/views/mobile/research/directions/detail')
const mobileNationBase = () => import('@/views/mobile/research/bases/nation-base')
const mobileOtherBase = () => import('@/views/mobile/research/bases/other-base')
// const mobileImportant = () => import('@/views/mobile/research/results/important')
const mobileAward = () => import('@/views/mobile/research/results/award')
const mobileProject = () => import('@/views/mobile/research/results/project')
const mobilePaper = () => import('@/views/mobile/research/results/paper')

// pc
const home = () => import('@/views/pc/home')
const about = () => import('@/views/pc/about')
const profile = () => import('@/views/pc/about/profile')
const leader = () => import('@/views/pc/about/leader')
const previous = () => import('@/views/pc/about/previous')
const office = () => import('@/views/pc/about/office')

const researchCenter = () => import('@/views/pc/center')

// const search = () => import('@/views/search')
const faculty = () => import('@/views/pc/faculty')
const teacher = () => import('@/views/pc/faculty/teacher')
const talent = () => import('@/views/pc/faculty/talent')
const facultyDetail = () => import('@/views/pc/faculty/detail')
const postdoctoral = () => import('@/views/pc/faculty/postdoctoral')

// const dynamic = () => import('@/views/pc/dynamic/index')
// const newsDetail = () => import('@/views/pc/dynamic/faits/detail')
// const info = () => import('@/views/pc/info/index')
const news = () => import('@/views/pc/info')

const cultivate = () => import('@/views/pc/cultivate')
const postgraduate = () => import('@/views/pc/cultivate/postgraduate')
const teachers = () => import('@/views/pc/cultivate/postgraduate/teachers')
const management = () => import('@/views/pc/cultivate/postgraduate/management')
const managementDetail = () => import('@/views/pc/cultivate/postgraduate/management-detail')
// const detail = () => import('@/views/cultivate/detail')
// const article = () => import('@/components/article')

const research = () => import('@/views/pc/research')
// const directionsDetails = () => import('@/views/research/directions/detail')
const bases = () => import('@/views/pc/research/bases')
const nationBase = () => import('@/views/pc/research/bases/nation-base')
const nationBaseDetail = () => import('@/views/pc/research/bases/nation-base/detail')
const otherBase = () => import('@/views/pc/research/bases/other-base')
const otherBaseDetail = () => import('@/views/pc/research/bases/other-base/detail')
// const platform = () => import('@/views/research/bases/platform')
const results = () => import('@/views/pc/research/results')
// const important = () => import('@/views/pc/research/results/important')
// const achievement = () => import('@/views/pc/research/results/achievement')
const award = () => import('@/views/pc/research/results/award')
const project = () => import('@/views/pc/research/results/project')
const paper = () => import('@/views/pc/research/results/paper')
// const resultsMessages = () => import('@/views/research/results/results-messages')
// const resultsDetail = () => import('@/views/research/results-detail')

Vue.use(Router)

const pc = [
  // pc 首页
  {
    path: '/',
    name: 'home',
    component: home,
  },

  // pc 概况
  {
    path: '/about',
    name: 'about',
    component: about,
    children: [
      {
        path: 'profile',
        name: 'profile',
        component: profile,
      },
      {
        path: 'leaders',
        name: 'leaders',
        component: leader,
      },
      {
        path: 'previous',
        name: 'previous',
        component: previous,
      },
      {
        path: 'office',
        name: 'office',
        component: office,
      },
    ],
  },

  // PC 研究中心
  {
    path: '/center',
    name: 'center',
    component: researchCenter
  },

  // pc 师资
  {
    path: '/faculty',
    name: 'faculty',
    component: faculty,
    children: [
      {
        path: 'teachers',
        name: 'teachers',
        component: teacher,
      },
      {
        path: 'talents',
        name: 'talents',
        component: talent,
      },
      {
        path: 'postdoc',
        name: 'postdoc',
        component: postdoctoral,
      },
      {
        path: 'detail/:id',
        name: 'teacher-detail',
        component: facultyDetail,
      }
    ],
  },

  // pc 新闻
  {
    path: '/info/:type',
    name: 'info',
    component: news,
    children: [
      {
        path: ':id',
        name: 'detail',
        component: mobileNewsDetail
      }
    ]
  },

  // pc 培养
  {
    path: '/cultivate',
    name: 'cultivate',
    component: cultivate,
    // TODO: redirect: '/cultivate/postgraduate/teachers',
    redirect: '/cultivate/postgraduate/managements',
    children: [
      {
        path: 'postgraduate',
        name: 'postgraduate',
        component: postgraduate,
        // TODO: redirect: '/cultivate/postgraduate/teachers',
        redirect: '/cultivate/postgraduate/managements',
        children: [
          {
            path: 'teachers',
            name: 'postgraduate-teachers',
            component: teachers,
          },
          {
            path: 'managements',
            name: 'managements',
            component: management,
          },
          {
            path: 'managements/:id',
            name: 'management-detail',
            component: managementDetail,
          },
        ]
      }
    ],
  },

  // pc 科研
  {
    path: '/research',
    name: 'research',
    component: research,
    redirect: '/research/bases/national',
    children: [
      {
        path: 'bases',
        name: 'bases',
        component: bases,
        redirect: '/research/bases/national',
        children: [{
          path: 'national',
          name: 'national',
          component: nationBase,
        },
        {
          path: 'corporate',
          name: 'corporate',
          component: otherBase,
        },
        {
          path: 'international',
          name: 'international',
          component: otherBase,
        },
        {
          path: 'national/:id',
          name: 'national-detail',
          component: nationBaseDetail,
        },
        {
          path: 'corporate/:id',
          name: 'corporate-detail',
          component: otherBaseDetail,
        },
        {
          path: 'international/:id',
          name: 'international-detail',
          component: otherBaseDetail,
        }],
      },
      {
        path: 'results',
        name: 'results',
        component: results,
        redirect: '/research/results/award',
        children: [{
          path: 'award',
          name: 'award',
          component: award,
        }, {
          path: 'project',
          name: 'project',
          component: project
        }, {
          path: 'paper',
          name: 'paper',
          component: paper
        }, {
          path: ':type/:id',
          name: 'result',
          component: mobileNewsDetail
        }]
      },
    ],
  },
  // {
  //   path: '/search/:text',
  //   name: 'search',
  //   component: search,
  // },
  {
    path: '*',
    name: '404',
    component: notFound,
  },
];

const mobile = [
  // mobile 首页
  {
    path: '/',
    name: 'home',
    component: mobileHome,
    children: [
      {
        path: '',
        name: 'mobileIndex',
        component: mobileIndex,
      },
      {
        path: '/about',
        name: 'about',
        redirect: '/about/profile',
        component: mobileAbout,
        children: [
          {
            path: 'profile',
            name: 'profile',
            component: mobileProfile,
          },
          {
            path: 'leaders',
            name: 'leaders',
            component: mobileLeaders,
          },
          {
            path: 'previous',
            name: 'previous',
            component: mobilePrevious,
          },
          {
            path: 'office',
            name: 'office',
            component: mobileContact,
          },
        ],
      },
    ]
  },
  // Mobile 研究中心
  {
    path: '/center',
    name: 'center',
    component: mobileCenter
  },
  // mobile 师资
  {
    path: '/faculty',
    name: 'faculty',
    component: teacherResource,
    redirect: 'faculty/teachers',
    children: [
      {
        path: 'teachers',
        name: 'teachers',
        component: teacherDetails,
      },
      {
        path: 'talents',
        name: 'talents',
        component: outstandingTeacher,
      },
      {
        path: 'postdoc',
        name: 'postdoc',
        component: postdoctor,
      },
      {
        path: 'detail/:id',
        name: 'teacher-detail',
        component: teacherInfo,
      },
    ],
  },

  // mobile 新闻
  {
    path: '/info/:type',
    name: 'info',
    component: newsAnnouncement,
    children: [
      {
        path: ':id',
        name: 'detail',
        component: mobileNewsDetail
      },
    ],
  },
  {
    path: '/header',
    name: 'mobileHeader',
    component: mobileHeader
  },

  // mobile 培养
  {
    path: '/cultivate',
    name: 'cultivate',
    component: mobileCultivate,
    children: [
      {
        path: 'postgraduate',
        name: 'postgraduate',
        component: mobileCultivateNav,
      },
      {
        path: 'postgraduate/teachers',
        alias: 'teachers',
        name: 'postgraduate-teachers',
        component: mobileTeachers,
      },
      {
        path: 'postgraduate/managements',
        name: 'managements',
        component: mobileManagement,
      },
      {
        path: 'postgraduate/managements/:id',
        name: 'management-detail',
        component: managementDetail,
      },
    ],
  },

  // mobile 科研
  {
    path: '/research',
    name: 'research',
    component: mobileResearch,
    children: [
      {
        path: '',
        name: 'nav',
        component: mobileResearchNav,
        children: [
          {
            path: 'bases',
            name: 'bases',
            component: mobileBases
          },
          {
            path: 'results',
            name: 'results',
            component: mobileResults
          },
        ]
      },
      {
        path: 'bases/national',
        alias: 'national',
        name: 'national',
        component: mobileNationBase,
      },
      {
        path: 'bases/corporate',
        name: 'corporate',
        component: mobileOtherBase,
      },
      {
        path: 'bases/international',
        name: 'international',
        component: mobileOtherBase,
      },
      {
        path: 'bases/national/:id',
        name: 'national-detail',
        component: nationBaseDetail,
      },
      {
        path: 'bases/corporate/:id',
        name: 'corporate-detail',
        component: otherBaseDetail,
      },
      {
        path: 'bases/international/:id',
        name: 'international-detail',
        component: otherBaseDetail,
      },
      {
        path: 'results/award',
        name: 'award',
        component: mobileAward,
      }, {
        path: 'results/project',
        name: 'project',
        component: mobileProject
      }, {
        path: 'results/paper',
        name: 'paper',
        component: mobilePaper
      }, {
        path: 'results/:type/:id',
        name: 'result',
        component: mobileNewsDetail
      }
    ]
  },

  {
    path: '*',
    name: '404',
    component: notFound
  }
]

const router = new Router({
  mode: 'history',
  routes: isMobile() ? mobile : pc,
})

router.afterEach((to) => {
  /* eslint-disable */
  wx.ready(() => {
    wx.onMenuShareTimeline({
      title: '上海交通大学人工智能学院',
      link: `https://${location.host}${to.fullPath}`,
      imgUrl: '/static/1483089417521-weather_live.png',
    });
    wx.onMenuShareAppMessage({
      title: '上海交通大学人工智能学院',
      desc: '上海交通大学人工智能学院',
      link: `https://${location.host}${to.fullPath}`,
      imgUrl: '/static/1483089417521-weather_live.png',
    });
  });
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js